import type { JobsInquiry } from '@/types/graphql';
import { JobsInquiryState } from '@/types/graphql';
import { Component, Vue } from 'vue-property-decorator';
import { JOB_APPLICATION_LOCAL_STORAGE_KEY, JOB_APPLICATION_TOOLTIP } from './constants';
import WarRoomJobApplicationBannerCurrentJobsInquiryQuery from './WarRoomJobApplicationBannerCurrentJobsInquiry.query';

@Component<WarRoomJobApplicationMixin>({
  name: 'WarRoomJobApplicationMixin',
  apollo: {
    currentJobsInquiry: {
      query: WarRoomJobApplicationBannerCurrentJobsInquiryQuery,
      error(error) {
        this.$notice.error(error);
      },
      update({ currentJobsInquiry }: { currentJobsInquiry: JobsInquiry }) {
        this.hasCompletedJobsOnboardingWithoutMatches =
          currentJobsInquiry?.state === JobsInquiryState.Filled && !currentJobsInquiry.activeHiringsCount;
      },
      skip() {
        return !this.$auth.loggedIn;
      },
      prefetch: false,
    },
  },
  mounted() {
    if (localStorage.getItem(JOB_APPLICATION_LOCAL_STORAGE_KEY)) {
      this.wasShownAndRefreshed = true;

      localStorage.removeItem(JOB_APPLICATION_LOCAL_STORAGE_KEY);

      return this.$tooltip.close(JOB_APPLICATION_TOOLTIP);
    }
  },
})
export default class WarRoomJobApplicationMixin extends Vue {
  hasCompletedJobsOnboardingWithoutMatches = false;
  wasShownAndRefreshed = false;
  hasRefreshEventTriggered = false;

  get wasJobBannerShown() {
    return this.$tooltip.isPresent(JOB_APPLICATION_TOOLTIP);
  }

  get isJobsBannerVisible() {
    return (
      this.$auth.loggedIn &&
      this.hasCompletedJobsOnboardingWithoutMatches &&
      !this.wasJobBannerShown &&
      !this.wasShownAndRefreshed
    );
  }

  handleJobsBannerClose() {
    return this.$tooltip.close(JOB_APPLICATION_TOOLTIP);
  }

  handleJobsBannerCloseOnReload() {
    if (this.hasRefreshEventTriggered) {
      return;
    }

    this.hasRefreshEventTriggered = true;

    if (this.isJobsBannerVisible) {
      localStorage.setItem(JOB_APPLICATION_LOCAL_STORAGE_KEY, 'true');
    }
  }
}
